import { DesktopPlayerContext, DesktopPlayerProvider } from "../PlayerContext.desktop";
import { MobilePlayerContext, MobilePlayerProvider }   from "../PlayerContext.mobile";

// Detect mobile browsers
const isMobile = /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent);

// Choose the appropriate context & provider
export const PlayerContext  = isMobile ? MobilePlayerContext  : DesktopPlayerContext;
export const PlayerProvider = isMobile ? MobilePlayerProvider : DesktopPlayerProvider;
